import dayjs from 'dayjs';
import _ from "global/underscore.js";
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {
    // Note: Currently only used by the Show.FormView in uploader_views.js
    Behaviors.SubmitContentValidation = Marionette.Behavior.extend({
        ui: {
            'submitContent': '#submit_content_button',
            'additionalTosInput': '.additional_tos_input',
            'tosInput': '.tos_input'
        },
        onShow: function() {
            this.ui.submitContent.one('click', this.submitContent.bind(this));
        },
        submitContent: function(ev) {
            var valid = true;

            // hide all the errors
            this.view.ui.nameInput.find('.error').hide();
            this.view.ui.nameInput.find('input').removeAttr('aria-required');
            //email
            this.view.ui.emailInput.find('.error').hide();
            this.view.ui.emailInput.find('.validate').hide();
            this.view.ui.emailInput.find('input').removeAttr('role aria-invalid aria-label')
            // dob
            // dob cannot be given aria attributes because it is a datepicker field. So 'required' is tabbable here
            this.view.ui.dobInput.find('.error').hide();

            var validChecks = [this.checkDob(), this.checkFullName(), this.checkEmail(), this.checkClientAgreementTos(), this.checkAdditionalFields()];

            valid = _.all(validChecks);

            if (valid) {
                // Check for minimum age requirement and if there is one and they do not meet it, do not collect their content
                var minAge = App.displayOptions.get('uploaderMinimumAge');
                var dob = this.view.model.get('dob');
                var ageRequirementMet = minAge && _.isTruthy(dob) ? dayjs().diff(dayjs(dob, 'MM-DD-YYYY'), 'years') >= minAge : true;

                this.ui.submitContent.addClass('disabled');
                this.view.trigger('update:breadcrumb', 'disabled');
                if (ageRequirementMet) {
                    this[this.view.options.source + 'Submit']();
                    this.view.triggerMethod('validation:success');
                } else {
                    this.view.trigger('show:failed:submission:panel');
                }
            } else {
                this.ui.submitContent.one('click', this.submitContent.bind(this));
                this.focusFirstErrorField();
            }
        },
        focusFirstErrorField: function() {
            var firstErrorField = this.$el
                .find('.error:visible, .validate:visible')
                .parent()
                .find('input')
                .first();
            firstErrorField.focus();
        },
        checkDob: function() {
            var valid = true;

            if (this.view.ui.dobInput.is(':visible')) {
                // The HTML5 type="date" is strictly in the format of YYYY-MM-DD
                var m = dayjs(this.view.ui.dobInputText.val(), 'YYYY-MM-DD', true);
                var today = dayjs();
                // Don't let people who are born in the future go through
                // Also don't allow people who are born before year 1920
                if (m.isValid() && m.isBefore(today) && m.isAfter('1920-01-01')) {
                    // Pixlee stores it in the format of MM-DD-YYYY
                    // So since it's a valid date, let's change it to MM-DD-YYYY
                    this.view.model.set('dob', m.format('MM-DD-YYYY'));
                } else {
                    this.view.ui.dobInput.find('.error').show();
                    valid = false;
                }
            }

            return valid;
        },
        checkFullName: function() {
            var valid = true;

            if (!_.isFalsy(this.view.ui.fullNameInputText.val())) {
                if (this.view.options.source === 'facebook') {
                    this.view.model.set('facebook_user_name', this.view.ui.fullNameInputText.val());
                }
                this.view.model.set('full_name', this.view.ui.fullNameInputText.val());
            } else {
                this.view.ui.nameInput.find('.error').show();
                this.view.ui.nameInput.find('input').attr('aria-required', 'true');
                valid = false;
            }
            return valid;
        },
        checkEmail: function() {
            var valid = true;

            if (!_.isFalsy(this.view.ui.emailInputText.val())) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(this.view.ui.emailInputText.val())) {
                    this.view.ui.emailInput.find('.validate').show();
                    this.view.ui.emailInput.find('input').attr({
                        'aria-invalid': 'true',
                        'role': 'alert'
                    });
                    valid = false;
                } else {
                    this.view.ui.emailInput.find('.validate').hide();
                    this.view.ui.emailInput.find('input').removeAttr('role aria-invalid');
                    this.view.model.set('email_address', this.view.ui.emailInputText.val());
                }
            } else {
                this.view.ui.emailInput.find('.error').show();
                this.view.ui.emailInput.find('input').attr('aria-required', 'true');
                valid = false;
            }

            return valid;
        },
        checkClientAgreementTos: function() {
            var valid = true;

            if (this.view.ui.clientTosHolder.is(':visible') && gon.display_options.clientTosRequired !== false) {
                valid = this.view.ui.clientTosCheckbox.is(':checked');

                this.view.ui.clientTosHolder.find('.error').toggle(!valid);

                if (!valid) {
                    this.view.ui.clientTosCheckbox.attr('aria-required', 'true');
                }
            }

            return valid;
        },
        checkAdditionalFields: function() {
            var valid = true;
            var model = this.view.model;
            // Check Additional TOS Fields
            valid = this.checkAndAddAdditionalTosFields(valid, {})['valid'];
            this.view.ui.additionalField.each(function() {
                var $this = $(this);
                var isRequired = $this.hasClass('required');
                if (!_.isFalsy($this.find('.additional_input').val())) {
                    $this.find('.error').hide();
                    $this.find('input').removeAttr('aria-required');
                    model.set($this.find('label').html(), $this.find('.additional_input').val());
                } else if (isRequired) {
                    valid = false;
                    $this.find('.error').show();
                    $this.find('input').attr('aria-required', 'true');
                }
            });

            return valid;
        },
        instagramSubmit: function() {
            this.submitPhotos();
        },
        facebookSubmit: function() {
            this.submitPhotos();
        },
        googleSubmit: function() {
            this.submitPhotos();
        },
        resolveNameAndEmail: function() {
            // Email address and name can be set by the client
            if (window._customerProvidedUserProfile && window._customerProvidedUserProfile.isImmutable) {
                return {
                    email: window._customerProvidedUserProfile.email,
                    name: window._customerProvidedUserProfile.name
                };
            } else {
                return {
                    email: this.view.model.get('email_address'),
                    name: this.view.model.get('full_name')
                };
            }
        },

        uploaderAdditionalFields: function() {
            const connectedUser = this.view.connectedUser;
            const uploaderAdditionalFields = {
                full_name: connectedUser.get('full_name'),
                email_address: connectedUser.get('email_address'),
                dob: connectedUser.get('dob'),
                uploader_product_input: this.view.model.get('uploader_product_input') || '',
                tos_accepted_at_utc: dayjs().unix(),
                tos_url: App.displayOptions.get('tosLink_text')
            };
            const additionalFields = $('.additional_field');

            if (additionalFields.length) {
                additionalFields.each(function() {
                    const $this = $(this);
                    const error = $this.find('.error');
                    const additionalInput = $this.find('.additional_input');
                    const isRequired = $this.hasClass('required');
                    if (!_.isFalsy(additionalInput.val())) {
                        error.hide();
                        const label = $this.find('label').html(); // get the name of the additional input field
                        uploaderAdditionalFields[label] = additionalInput.val(); // assign the value of the additional input field
                    } else if (isRequired) {
                        error.show();
                    }
                });
            }

            const additionalTosFields = $('.additional_tos_input');

            additionalTosFields.each(function() {
                const additionalTos = $(this);
                const input = additionalTos.find('input');
                const checked = input.is(':checked');

                // Save the TOS field to the album photo extra fields
                const additionalTosLabel = additionalTos.find('label');

                let fieldName;
                if (additionalTosLabel.length) {
                    const labelText = additionalTosLabel.text();
                    const computedLabelContent = window.getComputedStyle ? window.getComputedStyle(additionalTosLabel[0], ':before').content : 'none';
                    // If we are using css to set the label name (localization) use it as the name for additional TOS
                    fieldName = computedLabelContent === 'none' || !computedLabelContent ? labelText : computedLabelContent;
                } else {
                    fieldName = input.attr('aria-label');
                }

                if (uploaderAdditionalFields) {
                    uploaderAdditionalFields[fieldName] = checked;
                }
            });

            return uploaderAdditionalFields;
        },
        desktopSubmit: function() {
            const config = App.config.toJSON();
            const currentUser = App.currentUser.toJSON();
            const collection = this.view.collection.models;
            // https://developers.pixlee.com/reference/create-new-content-from-file
            const createUrl = config.distilleryUrl + 'api/v2/media/file?api_key=' + currentUser.single_access_token + '&time_stamp=' + Date.now();
            const nameAndEmail = this.resolveNameAndEmail();
            const album_id = App.request('get:current:album').get('id');
            const ajaxPromises = [];
            const uploaderAdditionalFields = this.uploaderAdditionalFields();

            for (let i = 0; i < collection.length; i++) {
                const model = collection[i];
                const formData = new FormData();

                const file = model.get('files')[0];
                formData.append('file', file);

                const data = {
                    album_id: album_id,
                    title: model.get('caption') || '',
                    approved: false,
                    product_skus: model.has('products') ? model.get('products').map(function(p) { return p.get('sku'); }) : [],
                    email: nameAndEmail.email,
                    username: nameAndEmail.name,
                    connected_user: this.view.connectedUser.toJSON(),
                    content_type: file.type,
                    uploader: true,
                    uploader_additional_fields: uploaderAdditionalFields
                };
                if (window._customerProvidedUserProfile && window._customerProvidedUserProfile.vendorId) {
                    data.vendor_id = window._customerProvidedUserProfile.vendorId;
                }
                formData.append('json', JSON.stringify(data));
                model.set('album_id', album_id);

                const promise = new Promise(function(resolve, reject) {
                    $.ajax({
                        type: 'POST',
                        url: createUrl,
                        processData: false, // prevent jquery from converting formData into query string
                        contentType: false,
                        dataType: 'json',
                        /**
                         *
                         * @param {{ connected_user_id: string, album_photo_id: string; photo_id: string }} data
                         */
                        success: function(data) {
                            App.commands.execute('photo:added', data);
                            resolve(data);
                        },
                        error: function(xhr, _textStatus, _errorThrown) {
                            if (typeof Sentry !== 'undefined') {
                                Sentry.captureMessage('Error uploading photo', {
                                    tags: {
                                        source: 'desktop',
                                    },
                                    contexts: {
                                        response: xhr.responseText,
                                        photo: model.toJSON(),
                                    }
                                });
                            }
                        },
                        data: formData
                    });
                });
                ajaxPromises.push(promise);
            }
            Promise.all(ajaxPromises).then(responses => {
                const confirmPanelData = {
                    uploadedAlbumPhotoIds: responses.map(r => r.album_photo_id),
                };
                if (responses.length > 0) {
                    confirmPanelData.connected_user_id = responses[0].connected_user_id;
                }
                this.view.trigger('show:confirm:panel', confirmPanelData);
            }).catch(_ => {
                App.execute('hide:uploader:loader');
                $('#uploader_error').show();
            });
        },
        // Add additional fields to currentUser and Album Extra Fields
        checkAndAddAdditionalTosFields: function(valid, extraFields) {
            var model = this.view.model;
            this.ui.additionalTosInput.each(function() {
                var additionalTos = $(this);
                var isRequired = additionalTos.hasClass('required');
                var input = additionalTos.find('input').first();
                var checked = input.is(':checked');
                if (isRequired && !checked) {
                    valid = false;
                    additionalTos.find('.error').toggle(!checked);
                } else if (isRequired && checked) {
                    valid = true;
                    additionalTos.find('.error').hide();
                }

                // Save the TOS field to the album photo extra fields
                var additionalTosLabel = additionalTos.find('label');
                var fieldName;
                if (additionalTosLabel.length) {
                    var labelText = additionalTosLabel.text();
                    var computedLabelContent = window.getComputedStyle ? window.getComputedStyle(additionalTosLabel[0], ':before').content : 'none';
                    // If we are using css to set the label name (localization) use it as the name for additional TOS
                    fieldName = computedLabelContent === 'none' ? labelText : computedLabelContent;
                } else {
                    fieldName = input.attr('aria-label');
                }

                model.set(fieldName, checked);
                if (extraFields['uploader_additional_fields']) {
                    extraFields['uploader_additional_fields'][fieldName] = checked;
                }
            });
            return {
                extraFields: extraFields,
                valid: valid
            };
        },
        /**
         * Submit photos for non desktop sources.
         * This works very similar to the desktop upload, except for some key differences:
         * - This uses a different API route.
         * - This does not upload a file through a multipart form. It instead passes a URL to the image.
         */
        submitPhotos: function() {
            App.execute('show:uploader:loader');
            // Add album photo id to uploadedAlbumPhotoIds if successfully uploaded
            this.uploadedAlbumPhotoIds = [];

            var nameAndEmail = this.resolveNameAndEmail();
            var album_id = App.request('get:current:album').get('id');
            var config = App.config.toJSON();
            var currentUser = App.currentUser.toJSON();
            var connectedUser = this.view.connectedUser.toJSON() || {};
            var collection = this.view.collection.models;
            // https://developers.pixlee.com/reference/create-new-content-from-file

            /**
             * @typedef {{
                    "album_id": number,
                    "title": string,
                    "email": string,
                    "username": string,
                    "photo_uri": string,
                    "avatar_url": string,
                    "approved": boolean,
                    "connected_user_id"?: number,
                    "product_skus"?: string[],
                    "category_names"?: string[],
                    "connected_user"?: any
                }} FileContentData
             */


            var createUrl = config.distilleryUrl + 'api/v2/media?api_key=' + currentUser.single_access_token;
            /**
             * @type {Promise<FileContentData>[]}
             */
            var ajaxPromises = collection.map(function(model) {
                /**
                 * @type {FileContentData}
                 */
                var data = {
                    album_id: album_id,
                    title: model.get('caption') || '',
                    email: nameAndEmail.email,
                    username: nameAndEmail.name,
                    // picture is for facebook/instagram, baseUrl is for google photos
                    photo_uri: model.get('picture') || model.get('baseUrl'),
                    approved: false,
                    product_skus: model.has('products') ? model.get('products').map(function(p) { return p.get('sku'); }) : [],
                    connected_user: connectedUser,
                    uploader: true
                };
                if (window._customerProvidedUserProfile && window._customerProvidedUserProfile.vendorId) {
                    data.vendor_id = window._customerProvidedUserProfile.vendorId;
                }
                return new Promise(function(resolve, reject) {
                    $.ajax({
                        type: 'POST',
                        url: createUrl,
                        dataType: 'json',
                        success: function(data) {
                            App.commands.execute('photo:added', data);
                            resolve(data);
                        },
                        error: function(xhr, _textStatus, _errorThrown) {
                            if (typeof Sentry !== 'undefined') {
                                Sentry.captureMessage('Error uploading photo', {
                                    tags: {
                                        source: 'social',
                                    },
                                    contexts: {
                                        response: xhr.responseText,
                                        photo: model.toJSON(),
                                    }
                                });
                            }
                        },
                        data: JSON.stringify(data)
                    });
                });
            });

            Promise.all(ajaxPromises).then(function(responses) {
                this.submitPhotosComplete(responses);
            }.bind(this));
        },
        submitPhotosComplete: function(responses) {
            App.execute('hide:uploader:loader');
            var confirmPanelData = {
                uploadedAlbumPhotoIds: responses.map(function(r) { return r.album_photo_id; }),
            }
            if (responses.length > 0) {
                confirmPanelData.connected_user_id = responses[0].connected_user_id;
            }
            if (!this.view.isDestroyed) {
                this.view.trigger('update:bread:crumb', 'four');
                this.view.trigger('show:confirm:panel', confirmPanelData);
            }
        },
    });

});
